import React from 'react';
import validator from "validator";


function stateMachine(state, { type, ...action }) {
    switch (type) {
    // When the user type something
    case 'input': {
        // override the content of the values with the value from the action
        const values = { ...state.values, ...action.values};
        return {
            ...state,
            values,
            invalid: !validator.isEmail(values.email || ''),
        };
        // When the user starts the request
    }
    case 'start-request':
        return {
            ...state,
            isLoading: true,
            formError: undefined
        };
        // When the user requests comes back successfull
    case 'success':
        return {
            ...state,
            focus: null,
            isLoading: false,
            success: true,
        };
        // When the user requests comes back failed
    case 'failure':
        return {
            ...state,
            focus: null,
            isLoading: false,
            success: false,
        };
        // After CLEAR_INTERVAL, reset the form
    case 'clear':
        return {
            ...state,
            isLoading: false,
            success: undefined,
            invalid: true,
            values: {},
        };
    case 'focus':
        return {
            ...state,
            focus: true,
        };
    case 'blur':
        return {
            ...state,
            focus: false,
        };
    case 'set-form-error':
        return {
            ...state,
            formError: true,
            isLoading: false,
            invalid: true,
            focus: false,
        };
    default:
        return state;
    }
}

function getInitialState(configuration) {

    const initialValues = {};
    configuration.fields.filter(f => configuration.types[f] === 'bool')
        .forEach(field => initialValues[field] = false);

    return {
        isLoading: false,
        focus: null,
        invalid: true,
        values: initialValues,
    };
};


/** The state machine for the  InputGenerator
  * it handles the form:
  * - values
  * - validation
  * - focus (only for 1 field)
  * - sumbission
  **/
export default function useStateMachine(initial) {
    return React.useReducer(stateMachine, initial, getInitialState);
}
